/* CTA "Me ajuda a escolher": abre o widget de chat da Shopify a partir do
   header, com aviso de primeira conversa e pintura do balão na cor da marca.
   O widget não expõe API pública — o acesso é pelo shadow root aberto do
   <shopify-chat>; se a Shopify mudar a estrutura interna, tudo aqui falha em
   silêncio e o CTA segue o href (WhatsApp). */
(function () {
  'use strict';
  if (window.__supChatLauncher) return;
  window.__supChatLauncher = true;

  var AVISO_KEY = 'suplementaria-chat-aviso-v1';

  function findActivator() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var queue = [host.shadowRoot];
    var guard = 0;
    while (queue.length && guard < 200) {
      var root = queue.shift();
      guard += 1;
      var btn = root.querySelector('button.activator');
      if (btn) return btn;
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i += 1) {
        if (all[i].shadowRoot) queue.push(all[i].shadowRoot);
      }
    }
    return null;
  }

  function openChat() {
    var btn = findActivator();
    if (!btn) return false;
    btn.click();
    return true;
  }

  function avisoAceito() {
    try {
      return window.localStorage.getItem(AVISO_KEY) === '1';
    } catch (err) {
      return true; /* sem storage (modo privado restrito): não bloquear o chat */
    }
  }

  function aceitarAviso() {
    try {
      window.localStorage.setItem(AVISO_KEY, '1');
    } catch (err) {
      /* sem storage o aviso volta na próxima visita — comportamento aceitável */
    }
  }

  /* Balão na cor da marca: injeta um <style> no MESMO shadow root que contém
     o activator (o widget aninha componentes e estilo não atravessa a
     fronteira). O token vem do :root — nenhum hex fora de critical.css. */
  function pintarBalao() {
    var btn = findActivator();
    if (!btn) return false;
    var root = btn.getRootNode();
    if (!root || root === document || root.querySelector('style[data-sup-brand]')) return !!root && root !== document;
    var navy = getComputedStyle(document.documentElement).getPropertyValue('--palette-navy').trim();
    var paper = getComputedStyle(document.documentElement).getPropertyValue('--palette-paper').trim();
    if (!navy) return false;
    var style = document.createElement('style');
    style.setAttribute('data-sup-brand', '');
    var fg = paper || '#fff';
    style.textContent =
      'button.activator{background:' + navy + ' !important;color:' + fg + ' !important;}' +
      'button.activator *{color:' + fg + ' !important;fill:currentColor !important;}' +
      /* Elevação via custom property herdada do host <shopify-chat> — é o
         único canal de fora para dentro do shadow root (auditoria
         2026-08-01: o balão cobria o CTA da barra fixa de compra). */
      '.activator-nudge{bottom:calc(20px + var(--sup-chat-lift, 0px)) !important;transition:bottom .2s ease;}' +
      '@media (prefers-reduced-motion: reduce){.activator-nudge{transition:none;}}';
    root.appendChild(style);
    return true;
  }

  /* PDP mobile: quando a barra fixa de compra aparece, o balão sobe a altura
     dela para não cobrir "Adicionar ao carrinho". Observa só o atributo
     hidden que o product-page.js alterna — sem listener de scroll. */
  function initStickyLift() {
    var bar = document.querySelector('.pdp-stickybar');
    var host = document.querySelector('shopify-chat');
    if (!bar || !host) return !bar; /* página sem stickybar: nada a fazer */
    var apply = function () {
      var lift = bar.hidden ? '0px' : bar.offsetHeight + 12 + 'px';
      host.style.setProperty('--sup-chat-lift', lift);
    };
    new MutationObserver(apply).observe(bar, { attributes: true, attributeFilter: ['hidden'] });
    apply();
    return true;
  }

  /* O widget monta tarde: tentar até pintar. Re-renderizações que descartam
     o estilo acontecem após interação com o próprio widget — o repaint disso
     fica no handler de clique abaixo (eventos compostos atravessam o shadow). */
  var tentativas = 0;
  var liftOk = false;
  var timer = window.setInterval(function () {
    tentativas += 1;
    if (!liftOk) liftOk = initStickyLift();
    if (pintarBalao() && liftOk && tentativas > 3) window.clearInterval(timer);
    if (tentativas > 40) window.clearInterval(timer);
  }, 1500);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('shopify-chat')) {
      window.setTimeout(pintarBalao, 600);
      window.setTimeout(pintarBalao, 2500);
    }
    var ok = event.target.closest('[data-chat-aviso-ok]');
    if (ok) {
      var dlgOk = ok.closest('dialog');
      aceitarAviso();
      if (dlgOk) dlgOk.close();
      openChat();
      return;
    }
    if (event.target.closest('[data-chat-aviso-close]')) return; /* form method=dialog fecha */

    var cta = event.target.closest('[data-chat-cta]');
    if (!cta) return;
    if (!findActivator()) return; /* widget ausente: deixa o href (WhatsApp) agir */
    event.preventDefault();
    if (avisoAceito()) {
      openChat();
      return;
    }
    var dlg = document.getElementById(cta.getAttribute('aria-controls'));
    if (dlg && typeof dlg.showModal === 'function') {
      dlg.showModal();
    } else {
      openChat();
    }
  });
})();
